import { Skeleton } from "antd";
import React from "react";

export const SkeletonBox = () => (
	<Skeleton.Avatar active size={100} shape="square" />
);
